<template>
  <Card class="employee-card">
    <!-- 按钮组 -->
    <section class="btn-wrap">
      <Button class="bkcc-btn btn" @click="getList">搜索</Button>
      <Button class="bkcc-btn btn" @click="searchReset">重置</Button>
      <Button class="bkcc-btn btn" @click="exportTable">导出</Button>
    </section>
    <!-- 搜索表单组 -->
    <Form :label-width="80">
      <Row :gutter="80">
        <Col span="8">
          <FormItem label="姓名">
            <Input v-model="searchForm.name" placeholder="请输入" />
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="审核状态">
            <Select v-model="searchForm.status" multiple>
              <Option
                v-for="item in statusList"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>

    <!-- 批量操作按钮 -->
    <section class="btn-wrap">
      <Button class="bkcc-btn btn" @click="deleteEmployee(selected)"
        >删除</Button
      >
      <Button class="bkcc-btn btn" @click="checkEmployee(selected, 1)"
        >审核</Button
      >
    </section>

    <!-- tabel -->
    <Table
      border
      stripe
      :columns="settingColumn"
      :data="peopleList"
      :loading="tableLoading"
      @on-selection-change="selectTableItem"
    ></Table>
    <!-- 分页 -->
    <Page
      class="page-wrap"
      show-total
      :total="total"
      :page-size="pageSize"
      @on-change="onPageChange"
    ></Page>
  </Card>
</template>

<script>
// 审核文字
const CHECKSTATUSTEXT = {
  0: "未通过",
  1: "已通过",
  2: "待审核"
};
export default {
  name: "qyemployee",
  components: {},
  props: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0, // 总数据量

      selected: [], // 选择的操作对象
      // 搜索的表单
      searchForm: {
        name: "",
        status: []
      },
      // 审核状态列表
      statusList: [
        {
          label: "已通过",
          value: 1
        },
        {
          label: "待审核",
          value: 2
        }
      ],

      tableLoading: false,
      settingColumn: [
        {
          type: "selection",
          align: "center",
          fixed: "left",
          width: 80
        },
        {
          title: "姓名",
          resizable: true,
          key: "userName",
          fixed: "left",
          minWidth: 200
        },
        {
          title: "联系电话",
          key: "phoneNO",
          resizable: true,
          minWidth: 200
        },
        {
          title: "审核状态",
          key: "statusText",
          resizable: true,
          minWidth: 200
        },
        {
          title: "操作",
          minWidth: 300,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.deleteEmployee([params.row.epidemicPeopleId]);
                    }
                  }
                },
                "[删除]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.row.checkStatus === 2 ? "" : "none"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.checkEmployee([params.row.epidemicPeopleId], 1);
                    }
                  }
                },
                "[审核通过]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.row.checkStatus === 2 ? "" : "none"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.checkEmployee([params.row.epidemicPeopleId], 0);
                    }
                  }
                },
                "[不通过]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                    display: params.row.checkStatus === 1 ? "" : "none"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.checkEmployee([params.row.epidemicPeopleId], 2);
                    }
                  }
                },
                "[取消审核]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px",
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.goDetail([params.row.epidemicPeopleId]);
                    }
                  }
                },
                "[详情]"
              )
            ]);
          }
        }
      ],
      peopleList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    exportTable() {
      let url = this.urlobj.qyEmployeeExport(this.companyId);
      let data = {
        token: this.$store.state.access_token,
        companyId: this.companyId,
        checkStatusList: this.searchForm.status.join(","),
        userName: this.searchForm.name
      };
      window.open(this.$util.concatUrl(url, data));
    },
    // 审核人员
    checkEmployee(idArr = [], checkStatus) {
      if (idArr.length === 0) return this.$Message.warning("未选中要审核人员");

      let url = this.urlobj.qyEmployeeCheck(this.companyId);
      let data = {
        companyId: this.companyId,
        epidemicPeopleIds: idArr.join(","),
        checkStatus
      };
      this.$post(url, data)
        .then(res => {
          this.$Message.success("操作成功");
          this.getList();
        })
        .catch(e => this.$Message.error(e.mssage));
    },
    // 删除人员
    deleteEmployee(idArr = []) {
      if (idArr.length === 0) return this.$Message.warning("未选中要删除人员");

      let url = this.urlobj.qyEmployeeDelete(this.companyId);
      let data = {
        epidemicPeopleIdList: idArr.join(",")
      };

      this.$delete(url, data)
        .then(res => {
          this.$Message.success("删除成功");
          this.getList();
        })
        .catch(e => this.$Message.error(e.mssage));
    },
    // 查询人员列表
    getList() {
      let url = this.urlobj.qyEmployeeList(this.companyId);
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userName: this.searchForm.name,
        checkStatusList: this.searchForm.status.join(",")
      };
      this.showTableLoading();
      this.$get(url, data)
        .then(res => {
          this.peopleList = res.rows.map(item => ({
            epidemicPeopleId: item.epidemicPeopleId,
            checkStatus: item.checkStatus,
            userName: item.userName,
            phoneNO: item.phoneNO,
            statusText: CHECKSTATUSTEXT[item.checkStatus]
          }));

          this.total = res.total;
        })
        .finally(() => this.hideTabelLoading());
    },
    onPageChange(e) {
      this.pageNum = e;
      this.getList();
    },
    // 重置搜索项
    searchReset() {
      this.searchForm.name = "";
      this.searchForm.status = [];

      this.getList();
    },
    showTableLoading() {
      this.tableLoading = true;
    },
    hideTabelLoading() {
      this.tableLoading = false;
    },
    selectTableItem(val) {
      this.selected = val.map(item => item.epidemicPeopleId);
    },
    goDetail(idArr) {
      let id = idArr.join();
      let communityId = this.$store.state.streetorcommunityid;
      this.$router.push({name: 'qyWorkerDetail', query: {id, communityId,fromWork:1}})

      // Shequ/fangyidetail?id=167&communityId=7009
    }
  },
  created() {
    this.companyId = this.$route.query.companyId;
  },
  mounted() {
    // 获取
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.employee-card {
  width: 97%;
  min-height: 600px;
  margin: 0 auto;
}
.btn-wrap {
  text-align: right;
  margin: 20px 0;
  .btn {
    margin-right: 10px;
  }
}
.page-wrap {
  text-align: center;
  margin-top: 50px;
}
</style>
